import { render, staticRenderFns } from "./DateWeekTab.vue?vue&type=template&id=6531040a&scoped=true"
import script from "./DateWeekTab.vue?vue&type=script&lang=js"
export * from "./DateWeekTab.vue?vue&type=script&lang=js"
import style0 from "./DateWeekTab.vue?vue&type=style&index=0&id=6531040a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531040a",
  null
  
)

export default component.exports